var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.checked)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip:top",value:(_vm.sendStartsAtTooltip),expression:"sendStartsAtTooltip",arg:"top"}],staticClass:"fas fa-check text-success"}):_c('div',[_c('div',{staticClass:"mb-2",domProps:{"innerHTML":_vm._s(_vm.dateTimeHtml)}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.time))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }